import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';
import { ChecksumCalculator } from '../utils/ChecksumCalculator.js';

/**
 * HKID validator following Single Responsibility Principle
 */
export class HkidValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Hong Kong Identity Card',
      pattern: /^[A-Z]{1,2}\d{6}[A-Z0-9]$/i,
      lengths: [8, 9]
    });
  }

  validateFormat(id) {
    const upperCaseId = id.toUpperCase();
    
    // Check length
    if (!this.config.lengths.includes(upperCaseId.length)) {
      return ValidationResult.invalid('HKID must be 8 or 9 characters long');
    }

    // Check pattern
    return this.validateRegex(
      upperCaseId, 
      this.config.pattern, 
      'HKID format must be 1-2 letters followed by 6 digits and a check character'
    );
  }

  validateChecksum(id) {
    const upperCaseId = id.toUpperCase();
    const expectedChecksum = ChecksumCalculator.calculateHkidChecksum(upperCaseId);
    const actualChecksum = upperCaseId.slice(-1);

    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(
        `Invalid HKID checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`
      );
    }

    return ValidationResult.valid('Valid HKID');
  }
}